import { FormAdapter, FormAlert, FormContainerOptions, FormControlProperties, FormControlType, FormValues } from '@omegagrid/form';
import { msg } from "@omegagrid/localize";
import { Query } from '@reporting/rp-types/ext';
import rp from '@reporting/rp-app-host';

export class QueryFormAdapter extends FormAdapter {

	private _query: Query;

	public duplicate: boolean = false;

	constructor(readonly idProject: number, private idQuery: number) { super() }

	async getQuery() {
		if (this._query) return this._query;
		this._query = this.idQuery ? await rp.ms('extensions').get<Query>(`queries/${this.idQuery}`) : {
			id_custom_page: this.idProject,
		};
		return this._query;
	}

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls(): Promise<FormControlProperties[]> {
		const query = await this.getQuery();
		if (this.duplicate) {
			query.description = `${query.description}_copy`;
			this._query.id_thread = this.idQuery = this._query.idz = null;
		}

		let r = 0;
		return [
			{ row: r, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name' },
			{ row: r, col: 1, type: FormControlType.TextInput, key: 'name', value: query.description, required: true },
			{ row: ++r, col: 0, type: FormControlType.Label, value: msg('Type'), for: 'type' },
			{
				row: r,
				col: 1,
				type: FormControlType.List,
				key: 'type',
				value: query.type,
				content: {
					sourceData: [
						{ k: '', v: `<${msg('none')}>` },
						{ k: 'definition', v: 'definition' },
						{ k: 'save', v: 'save' },
					],
					options: {selectMode: 'single', autoClose: true}
				}
			}
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const queryValues = values.get(0);
		const query = await this.getQuery();
		query.description = queryValues['name'] as string;
		query.type = queryValues['type'] as string || null;
		await rp.ms('extensions').post<Query>('queries', query);
		return true;
	}

}
